import * as React from "react";
export default class FeaturedItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (this.props.active ? React.createElement("a", { href: this.props.buttonLink, className: "featured-item" },
            React.createElement("div", { className: "featured-item__img", style: { backgroundImage: "url('" + this.props.bgPath + "')" } }),
            React.createElement("div", { className: "bg-shadow" },
                React.createElement("div", { className: "featured-caption" },
                    React.createElement("p", { className: "featured-header" }, this.props.header),
                    React.createElement("p", { className: "featured-title" }, this.props.title),
                    React.createElement("p", { className: "featured-desc" }, this.props.desc),
                    React.createElement("span", { className: "btn-primary btn-primary__clear" }, this.props.buttonText || "Click Here")),
                React.createElement("div", { className: "featured-img" },
                    this.props.imgPath != null && this.props.imgPath.trim().length > 0 ? React.createElement("img", { alt: "pic", src: this.props.imgPath }) : null,
                    React.createElement("div", { className: "featured-info" },
                        React.createElement("p", null, this.props.location),
                        React.createElement("p", null, this.props.drink))))) : React.createElement("div", { className: "featured-item" }));
    }
}
;
//# sourceMappingURL=featured-item.js.map